import React from 'react'
import { NavLink } from 'react-router-dom'
import { 
  LayoutDashboard, 
  Users, 
  MapPin, 
  BarChart3, 
  Settings,
  LogOut,
  X,
  Home,
  Key,
  Globe,
  Award,
  Trophy
} from 'lucide-react'
import { useAuth } from '../hooks/useAuth.jsx'

const Sidebar = ({ onClose }) => {
  const { logout } = useAuth()

  const navigation = [
    { name: 'Dashboard', href: '/', icon: LayoutDashboard },
    { name: 'Live Sessions', href: '/sessions', icon: Users },
    { name: 'Hunt Management', href: '/hunts', icon: MapPin },
    { name: 'Analytics', href: '/analytics', icon: BarChart3 },
    { name: 'Settings', href: '/settings', icon: Settings },
  ]

  const certificateNavigation = [
    { name: 'Certificates', href: '/certificates', icon: Trophy },
    { name: 'Virtual Prizes', href: '/prizes', icon: Award },
    { name: 'Prize Management', href: '/prize-management', icon: Settings },
  ]

  const handleNavClick = () => {
    // Close sidebar on mobile when navigation item is clicked
    if (onClose) {
      onClose()
    }
  }

  return (
    <div className="flex flex-col w-64 bg-white border-r border-gray-200 h-full shadow-sm">
      {/* Logo and close button */}
      <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200 bg-gradient-to-r from-primary-50 to-primary-100">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center shadow-sm">
            <MapPin className="w-5 h-5 text-white" />
          </div>
          <span className="text-lg font-semibold text-gray-900">Admin</span>
        </div>
        
        {/* Mobile close button */}
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {navigation.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.name}
              to={item.href}
              onClick={handleNavClick}
              className={({ isActive }) =>
                `flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                  isActive
                    ? 'bg-primary-50 text-primary-700 border-r-3 border-primary-600 shadow-sm'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                }`
              }
            >
              <Icon className="w-5 h-5 mr-3" />
              {item.name}
            </NavLink>
          )
        })}
        
        {/* Booking APIs */}
        <NavLink
          to="/booking-apis"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isActive
                ? 'bg-primary-50 text-primary-700 border-r-3 border-primary-600 shadow-sm'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
            }`
          }
        >
          <Globe className="w-5 h-5 mr-3" />
          Booking APIs
        </NavLink>
      </nav>

      {/* Certificates & Prizes Section */}
      <div className="px-4 py-2">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
          Certificates & Prizes
        </div>
        <nav className="space-y-1">
          {certificateNavigation.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-50 text-primary-700 border-r-3 border-primary-600 shadow-sm'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                  }`
                }
              >
                <Icon className="w-4 h-4 mr-3" />
                {item.name}
              </NavLink>
            )
          })}
        </nav>
      </div>

      {/* Logout */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={logout}
          className="flex items-center w-full px-3 py-2.5 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200"
        >
          <LogOut className="w-5 h-5 mr-3" />
          Logout
        </button>
      </div>
    </div>
  )
}

export default Sidebar
